import React, { Component } from 'react';
import PropTypes from 'prop-types';
import animateScrollTo from 'animated-scroll-to';
import trunc from 'trunc-text';
import { withRouter } from 'react-router-dom';
import exact from 'prop-types-exact';
import Button from '../../../common/button/Button';
// import Sharing from '../../../common/sharing/Sharing';
import HeaderTags from '../../../common/headerTags/HeaderTags';
import Placeholder from '../../../common/placeholder/Placeholder';
import ErrorPage from '../../../common/errorPage/ErrorPage';
import { transformHTML } from '../../../helpers/transformHTML';
import PlaceholderImage from '../../../common/placeholderImage/PlaceholderImage';
// import InteractiveContainer from '../../../common/interactiveContainer/InteractiveContainer';
import Spinner from '../../../common/Spinner/Spinner';
// import ProBadge from '../../../common/ProBadge/ProBadge';
import { showError, showInfo } from '../../../common/A1Alert/A1Alert';


// images paths
const A1MEDIA_FACEBOOK = 'https://a1media.antena1.com.br/image/promocao/1200x630/';
const BASE = 'https://a1media.antena1.com.br/image/promocao';


class SinglePromotions extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showInfo: false,
            showFixedMenu: false,
            keepMenuStop: false,
            // distancieRightFixedMenu: 0,
            distancieTopFixedMenu: 0,
            answerGiven: false,
        };

        this.promotionContentMain;

        this._listenerResize = this._listenerResize.bind(this);

        this._listenerScroll = this._listenerScroll.bind(this);

        this._setLayoutProps = this._setLayoutProps.bind(this);

        this._validateBusinessRules = this._validateBusinessRules.bind(this);

        this._scrollToRules = this._scrollToRules.bind(this);

        this._showGanhadores = this._showGanhadores.bind(this);
    }

    componentDidMount() {
        this.props.fetchSinglePromotionIfNeeded(this.props.slug);

        // go to top
        animateScrollTo(0, { speed: 700 });

        this._setLayoutProps();

        // bind event scroll
        if (window.addEventListener) { // For all major browsers, except IE 8 and earlier
            window.addEventListener('scroll', this._listenerScroll);

            window.addEventListener('resize', this._listenerResize);
        } else if (window.attachEvent) { // For IE 8 and earlier versions
            window.attachEvent('scroll', this._listenerScroll);

            window.attachEvent('resize', this._listenerResize);
        }
    }

    componentWillUnmount() {
        // clear the regulamento, answers, winners, ...
        this.props.resetPromotionData();

        // clear event listener when componet is unMount
        if (window.removeEventListener) {
            // For all major browsers, except IE 8 and earlier
            window.removeEventListener('scroll', this._listenerScroll);

            window.removeEventListener('resize', this._listenerResize);
        } else if (window.detachEvent) {
            // For IE 8 and earlier versions
            window.detachEvent('scroll', this._listenerScrol);

            window.detachEvent('resize', this._listenerResize);
        }
    }

    _saveAnswerCallback = (response) => {
        this.setState({
            answerGiven: response === 'success',
        });
    }

    _innerHTMLPromotionDescription() {
        if (this.props.singlePromotionData.id_promocao) {
            const descriptionPromotion = this.props.singlePromotionData.tx_descricao;

            return transformHTML(descriptionPromotion, `Imagem de conteúdo da promoção "${this.props.singlePromotionData.tx_promocao}"`);
        }

        return null;
    }

    _showGanhadores() {
        animateScrollTo(document.querySelector('.block-buttons'), { speed: 500, offset: -50 });

        if (this.props.canSeeWinners) {
            // Make request to get promotion's winner if verGanhadores button
            this.props.fetchPromotionWinners(this.props.singlePromotionData.id_promocao);

            // SET SHOW INFO TYPE
            this.setState((prevState) => ({
                showInfo: prevState.showInfo !== 'verGanhadores' ? 'verGanhadores' : false,
            }));
        } else {
            // Show an alert
            showInfo('É necessário estar logado para ver os ganhadores.');

            this.props.setProfileModalState(true);
        }
    }

    _validateBusinessRules() {
        const singlePromotionData = this.props.singlePromotionData;

        // DEFINE NECESSARY RULES
        const isEditable = singlePromotionData.rs_editavel;
        const isMultipleAnswer = singlePromotionData.rs_multiple;

        // RULE 1 - CHECK IF USER IS LOGGED
        // RULE 2 - CHECK IF USER IS PRO IN PRO EXCLUSIVE PROMOTIONS
        // RULE 3 - CHECK IF IS MULTIPLE ANSWER
        // RULE 4 - SET UNIQUE ANSWER AND GET USER ANSWERS

        animateScrollTo(document.querySelector('.block-buttons'), { speed: 500, offset: -50 });


        if (!this.props.isLogged) {
            showInfo('É necessário estar logado para participar desta promoção.');

            this.props.setProfileModalState(true);
        } else if (singlePromotionData.pro && !this.props.isPro) {
            showInfo('Essa promoção é exclusiva dos usuários PRO.',
                { duration: Infinity, extraClass: 'pro', buttons: [{ text: 'Saiba Mais', callback: () => this.props.history.push('/vantagens-da-assinatura-pro') }] });
        } else if (!this.props.registrationComplete) {
            showInfo('Por favor complete seu cadastro para poder participar desta promoção.');

            this.props.setProfileModalState(true);
        } else if (isMultipleAnswer === 'S') {
            // SET SHOW INFO TYPE
            this.setState((prevState) => ({
                showInfo: prevState.showInfo !== 'respostaMultipla' ? 'respostaMultipla' : false,
            }));
        } else {
            // FETCH ANSWERS
            this.props.fetchUserAnswer(singlePromotionData.id_promocao);

            if (isEditable === 'S') {
                // SET SHOW INFO TYPE
                this.setState((prevState) => ({
                    showInfo: prevState.showInfo !== 'respostaUnicaEditavel' ? 'respostaUnicaEditavel' : false,
                }));
            } else {
                // SET SHOW INFO TYPE
                this.setState((prevState) => ({
                    showInfo: prevState.showInfo !== 'respostaUnicaNaoEditavel' ? 'respostaUnicaNaoEditavel' : false,
                }));
            }
        }
    }

    _listenerScroll() {
        const scrollTop = document.body.scrollTop || document.documentElement.scrollTop;

        scrollTop >= 771 && !this.state.showFixedMenu // show right side fixed
            ? this.setState({
                showFixedMenu: true,
            })
            : scrollTop < 771 && this.state.showFixedMenu ? // show right side static
                this.setState({
                    showFixedMenu: false,
                }) : '';

        // keep menu stop in a determined distancie from bottom page
        const staticValue = 20;
        // get distancie maxScrol to stop
        const blockRightHeight = document.getElementsByClassName('block-right')[0] && document.getElementsByClassName('block-right')[0].offsetHeight;
        const footerHeight = document.getElementsByClassName('global-footer')[0] && document.getElementsByClassName('global-footer')[0].offsetHeight;
        const pageHeight = document.documentElement.offsetHeight;
        const maxScroll = pageHeight - (blockRightHeight + footerHeight + staticValue + this.state.distancieTopFixedMenu);

        if (scrollTop >= maxScroll && (!this.state.keepMenuStop && this.state.showFixedMenu)) {
            const marginTopToBeFixed = maxScroll - blockRightHeight;

            this.setState({
                keepMenuStop: marginTopToBeFixed - footerHeight + staticValue,
            });
        } else if (scrollTop < maxScroll && this.state.keepMenuStop) {
            this.setState({
                keepMenuStop: false,
            });
        }
    }

    _listenerResize() {
        this._setLayoutProps();
    }

    _setLayoutProps() {
        if (this.promotionContentMain && document.getElementById('Menu')) {
            // get distancie base to set in rigth to fixed Menu
            const distancieRightFixedMenu = this.promotionContentMain.offsetLeft;
            const distancieTopFixedMenu = document.getElementById('Menu').offsetHeight;

            this.setState({
                // eslint-disable-next-line react/no-unused-state
                distancieRightFixedMenu,
                distancieTopFixedMenu,
            });
        }
    }

    _scrollToRules() {
        animateScrollTo(document.querySelector('.block-buttons'), { speed: 500, offset: -50 });

        this.setState((prevState) => ({ showInfo: prevState.showInfo !== 'regulamento' ? 'regulamento' : false }));
    }

    render() {
        if (this.props.notFound) {
            return <ErrorPage
                errorNumber={404}
                backLink="/promocoes"
                title="NÃO ACHAMOS ESSA PROMOÇÃO :("
                message="Verifique se o link foi digitado corretamente."
                buttonText="Clique aqui para ver outras promoções"
            />;
        }

        const singlePromotionData = this.props.singlePromotionData.id_promocao && this.props.singlePromotionData;
        // @TODO rewrite this a bit so that we dont have to check in EVERY place if singlePromotionData is defined or not
        // const promotionState = singlePromotionData && singlePromotionData.get('st_promocao');
        // const promotionEnabled = singlePromotionData && singlePromotionData.get('tx_participar') === 'S';
        const isLoading = !!(this.props.lastSlug !== this.props.slug || !singlePromotionData);
        // const pro = singlePromotionData && !!singlePromotionData.get('pro');
        // DEFINE PATH TO PROMOTION IMAGE
        let imgSrc; let imgSrcSet; let imgSizes; let
            ogImage;

        if (singlePromotionData && singlePromotionData.tx_imageNew) {
            const img = encodeURI(singlePromotionData.tx_imageNew);
            imgSrc = `${BASE}/1024x536/${img}`;
            imgSrcSet = `${BASE}/560x292/${img} 560w, ${BASE}/752x392/${img} 752w, ${BASE}/1024x536/${img} 1024w`;
            imgSizes = '(max-width: 575px) 560px, (max-width: 767px) 752px, 1024px';
            ogImage = `${A1MEDIA_FACEBOOK}${img}`;
        } else if (singlePromotionData) {
            imgSrc = `${BASE}/${singlePromotionData.tx_banner}`;
            ogImage = imgSrc;
        }

        // Tags meta
        const headerTags = {
            title: `Promoção ${singlePromotionData && trunc(singlePromotionData.tx_promocao, 40)}`, // max 60 char in total, ' | Antena 1' (11 chars) is automatically added by the Headers Tag and is truncated
            meta:
                {
                    description: `Promoção ${singlePromotionData && singlePromotionData.tx_promocao}. Faça o cadastro e/ou realize o login, leia o regulamento e concorra ao prêmio!`,
                    keywords: `promoção, promoções, concurso cultural, ganhe, compartilhe, concorra, participe, ${singlePromotionData && singlePromotionData.tx_promocao}`,
                    'og:title': `Promoção ${singlePromotionData && singlePromotionData.tx_promocao}`,
                    'og:description': `Promoção ${singlePromotionData && singlePromotionData.tx_promocao}. Faça o cadastro e/ou realize o login, leia o regulamento e concorra ao prêmio!`,
                    'og:image': ogImage || '',
                },
        };

        // WORK IN  DATE
        // const promotionData = singlePromotionData && `${new Date(singlePromotionData.get('dt_promocao')).toLocaleDateString()} ${new Date(singlePromotionData.get('dt_promocao')).toLocaleTimeString()}`;
        // const titleToShare = `Antena 1 te convida para participar da promocao "${singlePromotionData && singlePromotionData.get('tx_promocao')}"`;
        // style to fixed menu
        // const styleMenu = {
        //     right: this.state.showFixedMenu
        //         ? this.state.distancieRightFixedMenu
        //         : 'inherit',
        //     marginTop: this.state.keepMenuStop
        //         ? this.state.keepMenuStop
        //         : 'inherit',
        //     position: this.state.showFixedMenu && !this.state.keepMenuStop
        //         ? 'fixed'
        //         : this.state.keepMenuStop ? 'absolute'
        //             : 'inherit',
        //     top: this.state.showFixedMenu && !this.state.keepMenuStop
        //         ? this.state.distancieTopFixedMenu
        //         : 'inherit',
        // };

        // const commentsLocation = `/promocoes/${singlePromotionData ? singlePromotionData.get('url_promocao') : ''}`;

        return (
            <section className="singlePromotionSection">
                <HeaderTags title={headerTags.title} meta={headerTags.meta} />
                <Button className="backToPage" title="Veja mais promoções." to="/promocoes">
                    <img src="/keyboard-right-arrow-button.svg" alt="Ícone seta para a esquerda" />
                    {' '}
                    Ver todas as promoções.
                </Button>
                <header className="tw-p-0">
                    {
                        isLoading ?
                            <h1>
                                <span className="loadingDots" />
                            </h1>
                            :
                            <React.Fragment>
                                <h2>
                                    {singlePromotionData && singlePromotionData.tx_promocao}
                                </h2>
                                <p>
                                    {singlePromotionData && singlePromotionData.tx_descricao_curta}
                                </p>
                            </React.Fragment>
                    }
                </header>
                {/* pro && <ProBadge className="singleContentProBadge" title="Conteúdo PRO" /> */}

                {/*
                <div className="shareBlock">
                    <Sharing
                        styleEffect="pulseIcon"
                        path={`/promocoes/${singlePromotionData && singlePromotionData.get('url_promocao')}`}
                        shareButtonsTo={['facebook', 'twitter', 'whatsapp', 'linkedin']}
                        iconSize={28}
                        widthBlockIcon={40}
                        facebook={{ quote: titleToShare, hashtag: '#Antena1' }}
                        twitter={{ title: titleToShare, hashtags: ['Participe', 'Antena1'] }}
                        whatsapp={{ title: titleToShare }}
                        linkedin={{ title: titleToShare }}
                    />
                </div>

                */}
                <div className="block-imagePromotion">
                    {
                        !isLoading ?
                            <PlaceholderImage
                                placeholderHeight="400px"
                                src={imgSrc}
                                srcSet={imgSrcSet}
                                sizes={imgSizes}
                                alt={`Promoção - ${singlePromotionData && singlePromotionData.tx_promocao}`}
                            />
                            :
                            <Placeholder minHeight="500px" />
                    }
                </div>
                <div ref={(promotionContentMain) => { this.promotionContentMain = promotionContentMain; }} className="promotion-contentMain">
                    <div className="block-center">
                        {/*
                        <InteractiveContainer />
                        */}

                        {/*
                        <div className="dateContainer">
                            <div>
                                <p className="datePublished">
                                    Publicada em &ensp;
                                    <time>
                                        {promotionData}
                                    </time>
                                </p>
                            </div>
                        </div>
                        */}
                        {
                            !isLoading ?
                                <div className="descriptionContent">
                                    {this._innerHTMLPromotionDescription()}
                                </div>
                                :
                                <Placeholder minHeight="500px" />
                        }

                        {/* <div className="block-buttons">
                            <Button onClick={this._validateBusinessRules} title="Quero Ganhar" className={(promotionState === 'E' || !promotionEnabled || this.state.answerGiven) ? 'inativeButton' : ''}>
                                Quero ganhar
                            </Button>
                            <Button
                                onClick={this._scrollToRules}
                                title="Ver Regulamento"
                            >
                                Regulamento
                            </Button>
                            <Button onClick={this._showGanhadores} className={`${promotionState !== 'E' && 'inativeButton'}`} title="Ver Ganhadores">
                                Ver Ganhadores
                            </Button>
                        </div> */}

                        <Info
                            singlePromotionData={singlePromotionData}
                            showInfo={this.state.showInfo}
                            promotionWinnersData={this.props.promotionWinnersData}
                            userAnswer={this.props.userAnswer}
                            saveAnswer={this.props.saveAnswer}
                            isFetching={this.props.isFetching}
                            answerGiven={this.state.answerGiven}
                            saveAnswerCallback={this._saveAnswerCallback}
                        />


                    </div>
                    {/* {
                        breakpoint.isSmall === false &&
                        breakpoint.isExtraSmall === false &&
                        breakpoint.isMedium === false ?
                            <div
                                className={`block-right ${this.state.showFixedMenu || this.state.keepMenuStop ? 'block-fixed' : ''}`}
                                style={styleMenu}
                            >
                                <Banner key={firstRectangleBannerConfig.adUnit} config={firstRectangleBannerConfig} />
                            </div>
                            : ''
                    } */}
                </div>
            </section>
        );
    }
}


class Info extends Component {
    static _validateTextareaLimit(event, maxLimit) {
        const answer = event.target;
        const length = answer.value.length;

        // STOP IF EXCEED MAXLIMIT
        if (length > maxLimit) {
            answer.value = answer.value.substring(0, maxLimit);
        }
    }

    constructor(props) {
        super(props);

        this.state = {
            editingAnswer: false,
        };
    }

    _handleEditAnswerButton = (e) => {
        e.preventDefault();

        this.setState((prevState) => ({
            editingAnswer: !prevState.editingAnswer,
        }));
    }

    _validateFields(idUserPromotion, event) {
        event.preventDefault();

        // GET VALUES
        const answer = event.target.answer;
        const terms = event.target.terms;
        const idPromotion = this.props.singlePromotionData.id_promocao;
        const checkBoxStyle = document.getElementsByClassName('checkBoxStyle')[0];

        // SHOW ALERT TO EMPTY TEXTAREA
        if (answer.value === 0 && terms.checked !== false) {
            showError('Preencha a caixa de texto com sua resposta.');

            answer.style.border = '1px solid red';
        } else {
            answer.style.border = '1px solid #aaa';
        }

        // SHOW ALERT TO NOT CHECKED TERMS
        if (terms.checked === false && answer.value !== 0) {
            showError('Você precisa ler  e aceitar o regulamento.');

            checkBoxStyle.style.border = '1px solid red';
        } else {
            checkBoxStyle.style.border = '1px solid #aaa';
        }

        // CHECK VALUES TO SAVE NEW ANSWER
        if (answer.value !== 0 && terms.checked) {
            this.props.saveAnswer(idUserPromotion, idPromotion, answer.value, this.props.saveAnswerCallback);
        } else if (answer.value === 0 && !terms.checked) {
            showError('Você precisa preencher a caixa de texto com sua resposta, ler  e aceitar o regulamento.');

            answer.style.border = '1px solid red';

            checkBoxStyle.style.border = '1px solid red';
        }
    }

    render() {
        // user has already answered, do not show the answer box (need to reload the page to give another answer)
        const showAnswerBox = this.props.answerGiven;

        const singleWordAnswer = this.props.singlePromotionData && this.props.singlePromotionData.rs_keywords === 'S';

        // UNIQUE ANSWER BUT IS NOT  ANSWERED
        const RULE1 = ((this.props.showInfo === 'respostaUnicaEditavel' || this.props.showInfo === 'respostaUnicaNaoEditavel')
            && this.props.userAnswer.length <= 0);
        // MULTIPLE ANSWER SO DON'T NEED CHECK
        const RULE2 = this.props.showInfo === 'respostaMultipla';
        // UNIQUE ANSWER AND ALREADY IS ANSWERED BUT IS EDITABLE
        const RULE3 = (this.props.showInfo === 'respostaUnicaEditavel' && this.props.userAnswer.length > 0);
        // TO SEE WINNERS
        const WINNERS = (this.props.showInfo === 'verGanhadores' && this.props.promotionWinnersData.length > 0);

        const maxNumChars = singleWordAnswer ? 30 : 350;
        const answerTitle = singleWordAnswer ?
            <h2>Resposta da promoção</h2>
            :
            <h2>
                Resposta da promoção (máx.
                {maxNumChars}
                {' '}
                caracteres)
            </h2>;
        const answerBoxExtraClass = singleWordAnswer ? ' singleWordAnswer' : '';

        return (
            <div id="mainInfoBlock" className="mainInfoBlock">

                {// SHOW REGULAMENTO
                    (this.props.showInfo === 'regulamento' && this.props.singlePromotionData.id_promocao) && (
                        <div className="showInfo">
                            <h2>Regulamento</h2>
                            <div className="blockInfoText">
                                {transformHTML(this.props.singlePromotionData.tx_regulamento)}
                            </div>
                        </div>
                    )
                }

                {// SHOW PROMOTION'S WINNERS
                    // first check if is fetching and  want to see promotion's winners
                    WINNERS && (
                        <div>
                            {
                                this.props.isFetching ?
                                    <Spinner />
                                    :
                                    <div className="showInfo">
                                        <div className="blockTitle">
                                            <h2>Ganhadores</h2>
                                            <hr />
                                        </div>
                                        <div className="blockInfoWinners">
                                            {
                                                this.props.promotionWinnersData.map((item, index) => {
                                                    const winnersQTD = this.props.promotionWinnersData.length;
                                                    const date = item.dt_vencedor ? new Date(item.dt_vencedor).toLocaleDateString() : '';
                                                    const classToBlock = winnersQTD >= 2 ? ' col-12 col-sm-12  col-md-6 col-lg-6 col-xl-6' : 'col-12';

                                                    return (
                                                        // eslint-disable-next-line react/no-array-index-key
                                                        <div className={classToBlock} key={index}>
                                                            <h3>
                                                                {`${item.tx_nome} ${item.tx_sobrenome}`}
                                                            </h3>
                                                            <p>
                                                                {`${item.tx_cidade} / ${item.id_estado}`}
                                                            </p>
                                                            <p className="date">
                                                                {`${date}`}
                                                            </p>
                                                            <hr />
                                                        </div>
                                                    );
                                                })
                                            }
                                        </div>
                                    </div>
                            }
                        </div>
                    )
                }

                {// MULTIPLE ANSWER SO DON'T NEED CHECK
                    RULE2 && !showAnswerBox && (
                        <div>
                            {
                                this.props.isFetching ?
                                    <Spinner />
                                    :
                                    <div className="showInfo">
                                        <div className="blockTitle">
                                            {answerTitle}
                                        </div>
                                        <form id="formAnswer" onSubmit={this._validateFields.bind(this, false)}>
                                            <div className={`blockMessage${answerBoxExtraClass}`}>
                                                {
                                                    singleWordAnswer ?
                                                        <input type="text" onKeyUp={(event) => this.constructor._validateTextareaLimit(event, maxNumChars)} name="answer" />
                                                        :
                                                        <textarea onKeyUp={(event) => this.constructor._validateTextareaLimit(event, maxNumChars)} name="answer" />
                                                }
                                                <input className="answerButton" type="submit" value="Enviar" />
                                            </div>
                                            <div className="blockCheckbox">
                                                <label htmlFor="rule2" className="labelCheck terms-checkbox">
                                                    <input
                                                        // onChange={this._handleInputChange.bind(this)}
                                                        id="rule2"
                                                        name="terms"
                                                        type="checkbox"
                                                        value="accept"
                                                    />
                                                    <span className="checkBoxStyle" />
                                                    <div className="textCheck">
                                                        Li e aceito o regulamento
                                                    </div>
                                                </label>
                                            </div>
                                        </form>
                                    </div>
                            }
                        </div>
                    )
                }
                {// UNIQUE ANSWER BUT IS NOT  ANSWERED
                    RULE1 && !showAnswerBox && (
                        <div>
                            {
                                this.props.isFetching ?
                                    <Spinner />
                                    :
                                    <div className="showInfo">
                                        <div className="blockTitle">
                                            {answerTitle}
                                        </div>
                                        <form id="formAnswer" onSubmit={this._validateFields.bind(this, false)}>
                                            <div className={`blockMessage${answerBoxExtraClass}`}>
                                                {
                                                    singleWordAnswer ?
                                                        <input type="text" onKeyUp={(event) => this.constructor._validateTextareaLimit(event, maxNumChars)} name="answer" />
                                                        :
                                                        <textarea onKeyUp={(event) => this.constructor._validateTextareaLimit(event, maxNumChars)} name="answer" />
                                                }
                                                <input className="answerButton" type="submit" value="Enviar" />
                                            </div>
                                            <div className="blockCheckbox">
                                                <label htmlFor="rule1" className="labelCheck terms-checkbox">
                                                    <input
                                                        id="rule1"
                                                        name="terms"
                                                        type="checkbox"
                                                        value="accept"
                                                    />
                                                    <span className="checkBoxStyle" />
                                                    <div className="textCheck">
                                                        Li e aceito o regulamento
                                                    </div>
                                                </label>
                                            </div>
                                        </form>
                                    </div>
                            }
                        </div>
                    )
                }

                {// UNIQUE ANSWER AND ALREADY IS ANSWERED BUT IS EDITABLE
                    RULE3 && !showAnswerBox &&
                    <div>
                        {
                            this.props.isFetching ?
                                <Spinner />
                                :
                                <div className="showInfo">
                                    <div className="blockTitle">
                                        {answerTitle}
                                    </div>
                                    <form id="formAnswer" onSubmit={this._validateFields.bind(this, this.props.userAnswer[0].id_participante_promocao)}>
                                        <div className={`blockMessage${answerBoxExtraClass}`}>
                                            {
                                                singleWordAnswer ?
                                                    <input type="text" onKeyUp={(event) => this.constructor._validateTextareaLimit(event, maxNumChars)} name="answer" disabled={!this.state.editingAnswer} className={!this.state.editingAnswer ? 'edit' : ''} defaultValue={this.props.userAnswer[0].tx_resposta} />
                                                    :
                                                    <textarea onKeyUp={(event) => this.constructor._validateTextareaLimit(event, maxNumChars)} name="answer" disabled={!this.state.editingAnswer} className={!this.state.editingAnswer ? 'edit' : ''} defaultValue={this.props.userAnswer[0].tx_resposta} />
                                            }
                                            {
                                                this.state.editingAnswer ?
                                                    <input className="answerButton" type="submit" value="Enviar" />
                                                    :
                                                    <input className="answerButton" type="button" value="Editar Resposta" onClick={this._handleEditAnswerButton} />
                                            }
                                        </div>
                                        {
                                            this.state.editingAnswer && (
                                                <div className="blockCheckbox">
                                                    <label htmlFor="rule3" className="labelCheck terms-checkbox">
                                                        <input
                                                            id="rule3"
                                                            name="terms"
                                                            type="checkbox"
                                                            value="accept"
                                                        />
                                                        <span className="checkBoxStyle" />
                                                        <div className="textCheck">
                                                            Li e aceito o regulamento
                                                        </div>
                                                    </label>
                                                </div>
                                            )
                                        }
                                    </form>
                                </div>
                        }
                    </div>
                }
                {// UNIQUE ANSWER AND ALREADY IS ANSWERED BUT IS NOT EDITABLE
                    (this.props.showInfo === 'respostaUnicaNaoEditavel' && this.props.userAnswer.length > 0) && (
                        <div>
                            <div className="showInfo">
                                <div className="blockTitle">
                                    <h2>Você já deu uma resposta nessa promoção. Boa sorte!</h2>
                                </div>
                                <form id="formAnswer">
                                    <div className={`blockMessage${answerBoxExtraClass}`}>
                                        {
                                            singleWordAnswer ?
                                                <input type="text" name="answer" disabled className="edit" defaultValue={this.props.userAnswer[0].tx_resposta} />
                                                :
                                                <textarea name="answer" disabled className="edit" defaultValue={this.props.userAnswer[0].tx_resposta} />
                                        }
                                    </div>
                                </form>
                            </div>
                        </div>
                    )
                }

            </div>
        );
    }
}


SinglePromotions.propTypes = exact({
    slug: PropTypes.string,
    singlePromotionData: PropTypes.object,
    fetchSinglePromotionIfNeeded: PropTypes.func,
    fetchPromotionWinners: PropTypes.func,
    promotionWinnersData: PropTypes.array,
    fetchUserAnswer: PropTypes.func,
    userAnswer: PropTypes.array,
    saveAnswer: PropTypes.func,
    isFetching: PropTypes.bool,
    lastSlug: PropTypes.string,
    setProfileModalState: PropTypes.func,
    isLogged: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool,
    ]).isRequired,
    registrationComplete: PropTypes.bool.isRequired,
    canSeeWinners: PropTypes.bool.isRequired,
    resetPromotionData: PropTypes.func.isRequired,
    notFound: PropTypes.bool.isRequired,
    isPro: PropTypes.bool.isRequired,
    history: PropTypes.object,
    /* eslint-disable react/no-unused-prop-types */
    // Injected through withRouter but not used
    match: PropTypes.object,
    staticContext: PropTypes.object,
    location: PropTypes.object,
    /* eslint-enable react/no-unused-prop-types */
});

Info.propTypes = exact({
    showInfo: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool,
    ]),
    singlePromotionData: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.object,
    ]),
    promotionWinnersData: PropTypes.array,
    userAnswer: PropTypes.array,
    saveAnswer: PropTypes.func,
    saveAnswerCallback: PropTypes.func,
    isFetching: PropTypes.bool,
    answerGiven: PropTypes.bool,
});

export default withRouter(SinglePromotions);
